(function () {
	'use strict';

	angular.module('gov.filters')
        .filter('amIsSame', filter);

	filter.$inject = [];

	function filter() {
		return function (value, otherValue, unit) {
			return moment(value).isSame(moment(otherValue), unit);
		};
	}

})();